import { Button } from '@material-ui/core'
import { useContext, useEffect } from 'react'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { sendCustomerProjectNotification } from '../../../actions/emailActions'
import { Context } from '../../../providers/ProjectContextProvider'
import ModalPopUp from '../../ModalPopUp/ModalPopUp'

const NotifyUser = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const { showNotifyUser, setShowNotifyUser } = useContext(Context)

  const { project } = useSelector(
    (state: RootStateOrAny) => state.projectDetails
  )
  const { success } = useSelector(
    (state: RootStateOrAny) => state.emailProjectNotification
  )

  useEffect(() => {
    if (success) {
      setShowNotifyUser(false)
      history.push(`/myquality/dashboard`)
    }
  }, [dispatch, history, setShowNotifyUser, success])

  const handleDoNotNotify = () => {
    setShowNotifyUser(false)
    history.push(`/myquality/dashboard`)
  }

  const handleNotify = () => {
    dispatch(sendCustomerProjectNotification(project))
  }

  return (
    <ModalPopUp
      title="Notify customer"
      setShowModal={setShowNotifyUser}
      showModal={showNotifyUser}
      variant="small"
    >
      <div className="form-container">
        <h4>Notify customer</h4>
        <p className="m-b-150">
          Would you like to email <strong>{project.userName}</strong> that{' '}
          <strong>{project.name}</strong> is ready for them to complete
          submission?
        </p>

        <div className="flex flex-end">
          <Button
            color="primary"
            variant="outlined"
            onClick={handleDoNotNotify}
          >
            Do not notify
          </Button>
          <Button
            color="primary"
            variant="contained"
            className="m-l-16"
            onClick={handleNotify}
          >
            Notify
          </Button>
        </div>
      </div>
    </ModalPopUp>
  )
}

export default NotifyUser
